import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetUserTeamMember, IResponseGetUserTeamMember } from "./types"
import { GetUserTeamMemberURL } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getUserTeamMember(
	{ ...rest }: IPropsGetUserTeamMember,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetUserTeamMember> =
			await apiPrivate.get(`${GetUserTeamMemberURL}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetUserTeamMember(
	data: IPropsGetUserTeamMember,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetUserTeamMember,
					unknown,
					IResponseGetUserTeamMember
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [ APIS_KEYS.GETUSERTEAMMEMBER,...Object.values(data)],
		queryFn: () => getUserTeamMember(data, apiPrivate),
		...options,
	})
}
